import React, { useEffect, useState, useRef } from "react";
import "./style.scss";

// import Button from "react-bootstrap/Button";
import logo from "../../../../../../src/assets/images/MAARG-Logo.png";
import launched from "../../../../../../src/assets/images/launched.jpg";
import placepic from "../../../../../../src/assets/images/placepic.png";
import Button from "../../../../AdminModule/Dashboard/AdminDashboard/Button";
import { useHistory } from "react-router-dom";

// import { getPredefineOptionsList } from "../../../AdminDashboard/AdminMentorAction/dependencies/action";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Select from "react-select";
// import Button from "../../../AdminDashboard/Button";
import { Modal } from "react-bootstrap";
import DateTimeDisplay from "./DateTimeDisplay";

// import { Countdown } from "../../NewCountdown/Countdown.js";

// import MultiselectorComp from "../../../../../MultiselectorComp/MultiselectorComp";
import {
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  TableBody,
} from "@material-ui/core";
import clsx from "clsx";
import makeStyles from "@material-ui/core/styles/makeStyles";
const customStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "rgba(0,0,0,0.05)",
    // paddingLeft: "10px",
    minHeight: "45px",
    // borderRadius: "var(--curve10)",
    color: "#333",
    // border: "1px solid #bfc0c1",
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#b499c7" : isFocused ? "#e4d7ee" : "white",
      color: isSelected ? "white" : "black",
      cursor: isDisabled ? "not-allowed" : "default",
    };
  },
  menu: (base) => ({
    ...base,
    width: "max-content",
    minWidth: "100%",
    fontSize: "14px",
  }),
};
const styles = {
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: "rgba(0,0,0,0.2)",
      // backgroundColor:  isSelected &&isFocused ? "#b499c7" : "#b499c7",

      color: "#000",
    };
  },
};

const useStyles = makeStyles((theme) => ({
  tableRightBorder: {
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: "rgba(0,0,0,0.1)",
    borderStyle: "solid",
    borderTop: "1px solid lightgray",
    // whiteSpace: "nowrap",
  },
  smallWidth: {
    width: "300px",
    fontWeight: "bold",
    color: "#b499c7",
  },
  tableFont: {
    fontSize: "16px",
    fontFamily: "Montserrat",

    "&::before": {
      [theme.breakpoints.down("md")]: {
        display: "none",
      },
    },
  },
  tableContainer: {
    padding: "10px",
  },
  lessPadding: {
    padding: "3px 16px",
  },
}));

const NewModal = (props) => {
  const Match_time = new Date("January 16, 2023 00:00:00").getTime();
  const now = new Date().getTime();
  const Gap = Match_time - now;
  const { intentToMentor, createGroupSession } = props;
  const [timeOver, setTimeover] = useState(Gap < 0 ? true : false);
  const history = useHistory();

  // localStorage.setItem("timerStatus", "ON");

  const classes = useStyles();
  const handleClose = () => {
    props.setModalOpen(false);
  };

  // another way for timer

  const [timerDays, setTimerDays] = useState("00");
  const [timerHours, setTimerHours] = useState("00");
  const [timerMinutes, setTimerMinutes] = useState("00");
  const [timerSeconds, setTimerSeconds] = useState("00");

  let interval = useRef();

  const Start_Timer = () => {
    // const Match_time = new Date("January 11, 2023 00:00:00").getTime();
    interval.current = setInterval(() => {
      // const now = new Date().getTime();
      // const Gap = Match_time - now;
      const TextDay = Math.floor(Gap / (1000 * 60 * 60 * 24));
      const TextHour = Math.floor(
        (Gap % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const TextMinute = Math.floor((Gap % (1000 * 60 * 60)) / (1000 * 60));
      const TextSecond = Math.floor((Gap % (1000 * 60)) / 1000);

      if (Gap < 0) {
        //Stop Timer
        setTimeover(true);
        clearInterval(interval.current);
        // props.setModalOpen(false);
      } else {
        //Set Timer
        setTimeover(false);
        setTimerDays(TextDay);
        setTimerHours(TextHour);
        setTimerMinutes(TextMinute);
        setTimerSeconds(TextSecond);
      }
    }, 1000);
  };

  useEffect(() => {
    Start_Timer();
    return () => {
      clearInterval(interval.current);
    };
  });

  const NewCount = () => {
    return (
      <div style={{ height: "299px" }}>
        {/* <h1>Countdown Timer</h1> */}

        {/* <CountdownTimer targetDate={dateTimeAfterThreeDays} /> */}
        {timeOver === false ? (
          <>
            {/* <h3 style={{ textAlign: "center", padding: "1% 0%" }}>
              {`${timerDays && timerDays} days to go!!`}
            </h3> */}
            <div
              className="show-counter"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <a
                href="javascript:void(0)"
                target="_blank"
                rel="noopener noreferrer"
                className="countdown-link"
                style={{
                  width: "fit-content",
                  padding: "0px",
                  border: "none",
                  pointerEvents: "none",
                }}
              >
                <DateTimeDisplay
                  value={timerDays}
                  type={"Days"}
                  isDanger={timerDays && timerDays <= 3}
                />
                <p style={{ color: "white" }}>:</p>
                <DateTimeDisplay
                  value={timerHours && timerHours}
                  type={"Hours"}
                  isDanger={false}
                />
                <p style={{ color: "white" }}>:</p>
                <DateTimeDisplay
                  value={timerMinutes && timerMinutes}
                  type={"Mins"}
                  isDanger={false}
                />
                <p style={{ color: "white" }}>:</p>
                <DateTimeDisplay
                  value={timerSeconds && timerSeconds}
                  type={"Seconds"}
                  isDanger={false}
                />
              </a>
            </div>
            <p
              style={{
                // paddingLeft: "20%",
                // paddingRight: "20%",
                padding: "3% 10%",
                textAlign: "center",
                color: "white",
              }}
            >
              {/* All Mentorship features will be enabled from 16th jan 2023..
              please stay tuned and Visit the Mentor startup Dashboard */}
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime
              mollitia, molestiae quas vel sint commodi repudiandae consequuntur
              voluptatum laborum
            </p>
          </>
        ) : (
          <>
            {/* <h3 style={{ textAlign: "center", padding: "1% 0%" }}>
              {`${timerDays && timerDays} days to go!!`}
            </h3> */}
            <div style={{ height: "100%" }}>
              <div
                className="popuploginbtn newuserTooltip"
                onClick={() => {
                  history.push("/login");
                }}
              >
                login
                <span className="tooltiptext popuploginButtons tooltip-bottom">
                  Login
                </span>
              </div>
              {/* <img src={launched} style={{ height: "100%", width: "100%" }} /> */}
            </div>
            {/* <p
              style={{
                
                padding: "3% 20%",
                textAlign: "center",
              }}
            >
              All features are enabled.
            </p> */}
          </>
        )}
      </div>
    );
  };

  return (
    <Modal
      backdrop="static"
      keyboard={false}
      size="lg"
      // show={props.modalOpen}
      show={false}
      onHide={() => props.setModalOpen(false)}
      aria-labelledby="example-modal-sizes-title-lg"
      style={{
        borderRadius: "7px",
        visibility:
          timeOver === false &&
          timerDays === "00" &&
          timerHours === "00" &&
          timerMinutes === "00" &&
          timerSeconds === "00"
            ? "hidden"
            : "visible",
      }}
      className={
        timeOver === false
          ? "meinmodalcontainercountdown"
          : "meinmodalcontainercountdowntimeover"
      }
    >
      <Modal.Header className="d-flex " style={{ borderBottom: "none" }}>
        <img src={logo} style={{ width: "15%", visibility: "hidden" }} />
        <Modal.Title
          className="modalHeadingncountdown"
          style={{ visibility: "hidden" }}
        >
          {timeOver === false ? "Launching Soon" : "We have launched!"}
        </Modal.Title>
        <div className="newuserTooltip closepopupicon">
          <button
            type="button"
            // className="btn-close btnnewsvg"
            className="btn-close"
            aria-label="Close"
            onClick={handleClose}
            style={{
              paddingRight: "0px",
            }}
          />
          <span
            className="tooltiptext  close-window"
            style={{ left: "-110px", top: "2px", width: "115px" }}
          >
            Close Window
          </span>
        </div>
      </Modal.Header>
      <Modal.Body>
        {/* <div>hello</div> */}
        <NewCount />

        {/* <Countdown /> */}
        {/* <div>
          <DateCountdown
            dateTo="January 12, 2023 00:00:00"
            callback={() => alert("Launched")}
          />
        </div> */}
        {/* <Countdown /> */}
      </Modal.Body>
      <Modal.Footer
        className="countdownmodalfooter"
        style={{ borderTop: "none" }}
        // style={{ justifyContent: "center" }}
      >
        {/* <Button
          style={{ width: "20%" }}
          variant="primary"
          onClick={handleClose}
        >
          Close
        </Button> */}
        {/* <Button

          onClick={handleClose}
          text="CLOSE"
          className="modalButton51 doc-upload newcolornow"
        ></Button> */}
      </Modal.Footer>
    </Modal>
  );
};
// const mapStateToProps = (state) => {
//   return {
//     getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
//   };
// };
export default NewModal;
